export const NETWORK_ERROR = 'Network Error! Try again later.';